import { render, staticRenderFns } from "./PawssordLogin.vue?vue&type=template&id=1fb6fbdd&scoped=true&"
import script from "./PawssordLogin.vue?vue&type=script&lang=js&"
export * from "./PawssordLogin.vue?vue&type=script&lang=js&"
import style0 from "./PawssordLogin.vue?vue&type=style&index=0&id=1fb6fbdd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6fbdd",
  null
  
)

export default component.exports